import * as React from 'react';
import { Translate } from '../../../../shared/LanguageService';
import * as Features from '../../../../shared/Features';
import { Link } from 'react-router-dom';

interface IAdvanceSearchListRowProps {
    orderId: number;
    user: any;
    className?: string;
    children?: any;
}

const AdvanceSearchListRow = (props: IAdvanceSearchListRowProps) => {
    if (Features.hasFeature(Features.ViewOrder, props.user)) {
        return (
            <td
                className={props.className ? `${props.className} clickable` : 'clickable'}
                title={Translate('orders/list/advance/row/view-order')}
            >
                <Link to={`/orders/${props.orderId}/basic`} className="nolink">
                    {props.children}
                </Link>
            </td>
        );
    }
    return <td className={props.className}>{this.props.children}</td>;
};

export default AdvanceSearchListRow;
